export default "__VITE_ASSET__fd172630__"